import { useQuery } from '@tanstack/react-query';
import { firestoreService } from '../services/firestore.service';

export const useForm = (formId: string) => {
  return useQuery({
    queryKey: ['form', formId],
    queryFn: () => firestoreService.getFormById(formId),
    enabled: !!formId,
    staleTime: 5 * 60 * 1000,
  });
};

export const useFormsByCategory = (categoryId: string) => {
  return useQuery({
    queryKey: ['forms', 'category', categoryId],
    queryFn: () => firestoreService.getFormsByCategory(categoryId),
    enabled: !!categoryId,
    staleTime: 5 * 60 * 1000,
  });
};
